export function isTextNode(node) {
    return node.type === 'text';
}
